import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EcoImg from 'eco-design/base/eco-img';
import { solutionConfig } from '../../../../config/pageConfig';

export default function Solution() {
    const { t } = useLang('Solution');
    const { locale } = getLocal();

    const config = solutionConfig[locale] || solutionConfig['eu'];

    const items = [
        {
            title: t('item1_title'),
            description: t('item1_desc'),
            btn: config.item1.disable ? t('item1_btn_disabled') : t('item1_btn'),
            footer: t('item1_footer'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1775554160029-vhxoi2-compressed-PC_BKW.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1775554357422-js0bif-compressed-MOB_BKW.jpg',
            link: config.item1.link,
            disable: config.item1.disable,
        },
        {
            title: t('item2_title'),
            description: t('item2_desc'),
            btn: config.item2.disable ? t('item2_btn_disabled') : t('item2_btn'),
            footer: t('item2_footer'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1775554173439-h4lfkn-compressed-PC_ocen2.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1775554378930-g2lqq5-compressed-MOB_ocen2.jpg',
            link: config.item2.link,
            disable: config.item2.disable,
        },
    ];

    const handleClick = (item: any, btnId: string) => {
        if (item.disable) {
            return;
        }
        window.open(item.link, '_blank');

        gtm.push({
            __btn_id1: btnId,
            __btn_id2: btnId,
            __btn_type: 'common',
            __bth_only_ef: true,
        });
    };

    return (
        <div className={`${styles.Solution} GtmModuleData-section`}>
            <div className="title">{t('title')}</div>
            <div className="list">
                {items.map((item, index) => (
                    <div className="item" key={index}>
                        <EcoImg pc={item.pc} pad={item.pad} h5={item.pad} />
                        <div className="right-box">
                            <div className="block-t">
                                <div className="box-title">{item.title}</div>
                                <div className="box-description">{item.description}</div>
                            </div>
                            <div className="block-b">
                                <div
                                    className={`box-btn GtmModuleData-btn-common ${index === 0 ? 'box-btn-item1' : 'box-btn-item2'} ${
                                        item.disable ? 'disabled' : ''
                                    }`}
                                    data-btn-id={index === 0 ? 'box-btn-item1' : 'box-btn-item2'}
                                    onClick={() => handleClick(item, index === 0 ? 'box-btn-item1' : 'box-btn-item2')}
                                >
                                    {item.btn}
                                </div>
                                <div className="box-footer">{item.footer}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
